"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ClearableInput = _interopRequireDefault(require("../clearableInput/ClearableInput"));

var TreeSearch = /*#__PURE__*/_react.default.memo(function (props) {
  var value = props.value,
      className = props.className,
      placeholder = props.placeholder,
      onChange = props.onChange;
  var classes = (0, _classnames.default)('TreeSearch', className);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'input-group flex-1-0'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'input-group-addon'
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'rioglyph rioglyph-search',
    "aria-hidden": 'true'
  })), /*#__PURE__*/_react.default.createElement(_ClearableInput.default, {
    value: value,
    onChange: onChange,
    placeholder: placeholder
  })));
});

TreeSearch.displayName = 'TreeSearch';
TreeSearch.defaultProps = {
  onChange: function onChange() {}
};
TreeSearch.propTypes = {
  value: _propTypes.default.string,
  onChange: _propTypes.default.func,
  placeholder: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = TreeSearch;
exports.default = _default;